import React from 'react';
import classnames from 'classnames';
import classes from './tooltip.scss';
function Tooltip({
  className,
  tooltipText,
  direction = 'bottom'
}) {
  return /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.tooltip, className, classes[direction]),
    "data-tooltip": tooltipText || 'Tooltip'
  });
}
export default Tooltip;